export default __webpack_public_path__ + "static/media/logo.940299d8.svg";